import BgMusic from "../assets/audio/bg_music.wav";
import BajajSound from "../assets/audio/bajaj.wav";
import WinningSound from "../assets/audio/win.wav";
let bgMusicAudio = null;
let bajajSound = null;
let winningSound = null;
let disabledSounds = false;


export function setDisabledSounds(disabled) {
    disabledSounds = disabled;
    if (disabled) {
        stopBajajSound();
        
    }
}


export function playBgMusic() {

    
    if (bgMusicAudio) {
        bgMusicAudio.play();
        return;
    }
    bgMusicAudio = new Audio(BgMusic);
    bgMusicAudio.volume = 0.3;
    bgMusicAudio.loop = true;
    bgMusicAudio.play();
}

export function stopBgMusic() {
    
    if (bgMusicAudio) {
        bgMusicAudio.pause();
        bgMusicAudio.currentTime = 0;
    }
}
export function playBajajSound() {
    if (disabledSounds) return;
    bajajSound = new Audio(BajajSound);
    bajajSound.volume = 0.8;
    bajajSound.loop = true;
    bajajSound.play();
}

export function stopBajajSound() {
    if (bajajSound) {
        bajajSound.pause();
        bajajSound.currentTime = 0;
    }
}

export function playWinningSound() {
    if (disabledSounds) return;
    winningSound = new Audio(WinningSound);
    winningSound.volume = 1;
    winningSound.play();
}

